// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LanguagesEvaluation_wrapper__1DM1p","list_wrapper":"LanguagesEvaluation_list_wrapper__1_kI2"};